
export const colorType = [
  {
    value: 'black',
    label: 'vehicles.imports.colorOptions.black',
  },
  {
    value: 'blue',
    label: 'vehicles.imports.colorOptions.blue',
  },
  {
    value: 'brown',
    label: 'vehicles.imports.colorOptions.brown',
  },
  {
    value: 'green',
    label: 'vehicles.imports.colorOptions.green',
  },
  {
    value: 'orange',
    label: 'vehicles.imports.colorOptions.orange',
  },
  {
    value: 'purple',
    label: 'vehicles.imports.colorOptions.purple',
  },
  {
    value: 'red',
    label: 'vehicles.imports.colorOptions.red',
  },
  {
    value: 'white',
    label: 'vehicles.imports.colorOptions.white',
  },
  {
    value: 'yellow',
    label: 'vehicles.imports.colorOptions.yellow',
  },
  {
    value: 'gray',
    label: 'vehicles.imports.colorOptions.gray',
  },
  {
    value: 'gold',
    label: 'vehicles.imports.colorOptions.gold',
  },
  {
    value: 'silver',
    label: 'vehicles.imports.colorOptions.silver',
  },
];

export const bodyType = [
  {
    value: 'coupe',
    label: 'vehicles.imports.bodyTypeOptions.coupe',
  },
  {
    value: 'compact',
    label: 'vehicles.imports.bodyTypeOptions.compact',
  },
  {
    value: 'convertible',
    label: 'vehicles.imports.bodyTypeOptions.convertible',
  },
  {
    value: 'van',
    label: 'vehicles.imports.bodyTypeOptions.van',
  },
  {
    value: 'hatchback',
    label: 'vehicles.imports.bodyTypeOptions.hatchback'
  },
  {
    value: 'suv',
    label: 'vehicles.imports.bodyTypeOptions.suv'
  },
  {
    value: 'limousine',
    label: 'vehicles.imports.bodyTypeOptions.limousine',
  },
  {
    value: 'station_wagon',
    label: 'vehicles.imports.bodyTypeOptions.stationWagon'
  },
  {
    value: 'transporter',
    label: 'vehicles.imports.bodyTypeOptions.transporter'
  }
];



export const fuelType = [
  {
    value: 'gasoline',
    label: 'vehicles.imports.fuelTypeOptions.gasoline',
  },
  {
    value: 'diesel',
    label: 'vehicles.imports.fuelTypeOptions.diesel',
  },
  {
    value: 'electric',
    label: 'vehicles.imports.fuelTypeOptions.electric',
  },
  {
    value: 'cng',
    label: 'vehicles.imports.fuelTypeOptions.cng',
  },
  {
    value: 'lpg',
    label: 'vehicles.imports.fuelTypeOptions.lpg',
  },
  {
    value: 'hydrogen',
    label: 'vehicles.imports.fuelTypeOptions.hydrogen',
  },
  {
    value: 'hybrid',
    label: 'vehicles.imports.fuelTypeOptions.hybrid',
  },
];